import { TableRow } from './components';
import { TableBodyProps } from './interface';
import { TableBody as Body } from '@mui/material';

export default function TableBody(props: TableBodyProps) {
  const { selectedUsers, users, setSelectedUsers } = props;

  return (
    <Body>
      {users.map(user => (
        <TableRow
          key={user.uid}
          user={user}
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
        />
      ))}
    </Body>
  );
}
